
import { BrowserRouter as Router, Routes, Route} from "react-router-dom"; // Import routing components
//import logo from "./assets/logo_white.svg";
import ec_logo from "./assets/logo-ec--en.svg";
import { Box, Stack, Container, Button, AppBar, Toolbar, Menu, MenuItem, Avatar, Tooltip, Typography, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "./App.css";
import ParticipantForm from "./formViews/ParticipantForm";
import StartPage from "./StartPage";
import ParticipantConnectorForm from "./formViews/ParticipantConnectorForm";
import ParticipantListOfConnectors from "./formViews/ParticipantListOfConnectors";
import UserRegistryHome from "./UserRegistryHome";
import ParticipantList from "./participants/ParticipantListWithsSorting";
import SubmissionSuccess from "./formViews/SubmissionSuccess";
import PrivateRoute from "./PrivateRoute";
import { USER_ACTIONS } from "./config/auth";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import setupAxiosInterceptors from "./config/setupAxios";
import { keycloak, setAuthKeycloak } from "./config/auth";
import MainNavigation from "./MainNavigation";

function App() {
  const { keycloak } = useKeycloak();
  const isAuth = keycloak.authenticated;

  useEffect(() => {
    setupAxiosInterceptors(keycloak);
    setAuthKeycloak(keycloak);
  });

  return (
    <>
      <Router>
        <MainNavigation />
        <Container maxWidth="lg" sx={{mb: 3}}>
          <Stack sx={{ mb: 1 }}>
            {/* <Box sx={{ pt: 2 }}>
              {isAuth && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    onClick={() => {
                      var base_url = window.location.origin;
                      keycloak.logout({ redirectUri: base_url });
                    }}
                    variant="contained"
                  >
                    logout
                  </Button>
                </div>
              )}
                  </Box> */}
            <Box>
              <Routes>
                <Route path="/" element={<StartPage />} />
                <Route path="/participant-form" element={<ParticipantForm />} />
                <Route
                  path="/participant-form/:id"
                  element={<PrivateRoute action={USER_ACTIONS.UPDATE_OWN_FORM}>{<ParticipantForm />}</PrivateRoute>}
                />
                <Route
                  path="/connector-form"
                  element={<PrivateRoute action={USER_ACTIONS.UPDATE_OWN_FORM}><ParticipantConnectorForm /></PrivateRoute>}
                />
                <Route
                  path="/connector-form/:id"
                  element={<PrivateRoute action={USER_ACTIONS.UPDATE_OWN_FORM}><ParticipantConnectorForm /></PrivateRoute>}
                />
                <Route
                  path="/management"
                  element={<PrivateRoute action={USER_ACTIONS.UPDATE_OWN_FORM || USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY || USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY}><UserRegistryHome /></PrivateRoute>}
                />
                 <Route
                  path="/connector-list"
                  element={<PrivateRoute action={USER_ACTIONS.UPDATE_OWN_FORM || USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY}><ParticipantListOfConnectors /></PrivateRoute>}
                />
                <Route
                  path="/submission-success"
                  element={<SubmissionSuccess />}
                />
                <Route
                  path="/participant-list"
                  element={<PrivateRoute action={USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY || USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY}>{<ParticipantList />}</PrivateRoute>}
                />
              </Routes>
            </Box>
          </Stack>
        </Container>
        <footer className="site-footer">
          <Container maxWidth="lg">
            <Grid container justifyContent={"space-between"} spacing={2}>
              <Grid size={6}>
                <a href="https://commission.europa.eu/index_en">
                  <img
                    className="ecl-site-footer__logo-image"
                    src={ec_logo}
                    alt="European Commission logo"
                  />
                </a>
              </Grid>
              {/* <Grid size={4}>
                <Stack spacing={2}>
                  <div className="site-footer__title">Terms & Privacy</div>
                  <a href="https://language-data-space.ec.europa.eu/data-processing-agreement" rel="external" target="_blank">Privacy policy</a>
                </Stack>
                </Grid> */}
              <Grid size={6}>
                <Stack spacing={2}>
                  <div className="site-footer__title">About</div>
                  <a href="https://language-data-space.ec.europa.eu/index_en" rel="external" target="_blank">Learn more about the European Language Data Space</a>
                </Stack>
              </Grid>
            </Grid>
          </Container>
        </footer>
      </Router>
    </>
  );
}

export default App;
